// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
// 引入路由
import router from './router';
// 引入状态管理
import store from './vuex/store';
// 引入icon
import './assets/icon/iconfont.css'
// 
import './styles/common.css'
// 引入echarts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

import axios from 'axios';
Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

// 使用element UI
Vue.use(ElementUI);
// 过滤器
import * as custom from './utils/util'
import { getInfo } from "./api/userMG";

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})

// 路由拦截器
router.beforeEach((to, from, next) => {
    const urlParams = new URLSearchParams(window.location.search);
    const crossToken = urlParams.get('token'); // 获取URL中的token参数（其他系统跳转时携带）

    if (crossToken) {
        localStorage.setItem('logintoken', crossToken);
        window.history.replaceState({}, document.title, to.path);
        getInfo()
            .then((res) => {
                if (res.msg == "success") {
                    localStorage.setItem("user_info", JSON.stringify(res.data));
                    switch (res.data.roleId) {
                        case 2:
                            next('/task/merchantList');
                            break;
                        case 3:
                            next('/agent/index');
                            break;
                        case 4:
                            next('/sales/index');
                            break;
                        default:
                            next('/index/work');
                    }
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            })
            .catch((err) => {
                this.$message({
                    type: "error",
                    message: "获取商户信息失败，请刷新",
                });
            });
    } else {
        proceedWithRouting(to, from, next);
    }
})

function proceedWithRouting(to, from, next) {
    if (to.matched.length !== 0) {
        if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
            if (Boolean(localStorage.getItem('logintoken'))) {
                next();
            } else {
                next({
                    path: '/login',
                    query: { redirect: to.fullPath }
                });
            }
        } else {
            if (Boolean(localStorage.getItem('logintoken'))) { // 已登录状态
                if (to.path !== '/' && to.path !== '/login') {
                    next();
                } else {
                    // 根据角色跳转到对应首页
                    const user = JSON.parse(localStorage.getItem('user_info') || '{}');
                    switch (user.roleId) {
                        case 2:
                            next('/task/merchantList');
                            break;
                        case 3:
                            next('/agent/index');
                            break;
                        case 4:
                            next('/sales/index');
                            break;
                        default:
                            next('/index/work');
                    }
                }
            } else {
                next();
            }
        }
    } else {
        next({
            path: '/login',
            query: { redirect: to.fullPath }
        });
    }
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
    data: {
        // 空的实例放到根组件下，所有的子组件都能调用
        Bus: new Vue()
    }

})


// WEBPACK FOOTER //
// ./src/main.js